import Rollbar from 'rollbar';
import { ILoggingOptions } from '../models/ILoggingOptions';


export function rollbarFactory(options: ILoggingOptions): Rollbar {
    if (!options.enableSending || !options.rollbarAccessToken) {
        return null;
    }

    const rollbar: Rollbar = new Rollbar({
        accessToken: options.rollbarAccessToken,
        captureUncaught: true,
        captureUnhandledRejections: true,
        environment: location.origin,
    });
    const hiddenRollbarProps = <{ client: Rollbar }><unknown>rollbar;
    rollbar.wait = (callback: () => void) => hiddenRollbarProps.client.wait(callback);
    return rollbar;
}

